import React, { useEffect, useState } from "react";
import "./style.css";
import Infomation from "../../Components/Assets/Infomation";
import { Label } from "reactstrap";
import {
  jwtDecodes,
  resetPassword,
  userFirstTimeDisable,
} from "../../Services/Admin/Api";
import Loader from "../../Components/Assets/Loader";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { userEmail, userRole } from "../../Components/Assets/userData";

export default function () {
  const [password, setPassword] = useState();
  const [confirmPassword, setConfirmPassword] = useState();
  const [eye, setEye] = useState(true);
  const [confirmEye, setConfirmEye] = useState(true);
  const [infoError, setInfoError] = useState(false);
  const [error, setError] = useState(false);
  const [check, setCheck] = useState(false);
  const [loading, setLoading] = useState(false);
  const [role, setRole] = useState("");

  const navigate = useNavigate();

  const validate = (password) => {
    return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{12,}$/.test(
      password
    );
  };

  const handleChangePass = (e) => {
    setPassword(e.target.value);
    setError(false);
    setCheck(false);
  };
  const handleconfirmPass = (e) => {
    setConfirmPassword(e.target.value);
    setError(false);
    setCheck(false);
    setInfoError(false);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate(password)) {
      setError(true);
    } else {
      if (password === confirmPassword) {
        setLoading(true);
        await resetPassword({
          email: sessionStorage.getItem("email"),
          password: password,
          role:role
        })
          .then(async (res) => {
            console.log(res);
            setLoading(false);
            let res1 = await userFirstTimeDisable({
              email: userEmail(),
              role: userRole(),
            }).catch((err) => {
              console.log(err);
            });
            console.log(res1);
            navigate("/passwordChange");
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        setCheck(true);
        console.log("inCorrect password match");
        setInfoError(true);
      }
    }
  };
  useEffect(() => {
    jwtDecodes().then((e) => {
      setRole(e.role);
    });
  }, []);
  return (
    <>
      <form onSubmit={(e) => handleSubmit(e)}>
        <div className="main-container">
          <div className="left-contain">
            <div className="logoFixed">
              <span className="eLogo">E-Valuators App</span>
            </div>
          </div>
          <div className="right-contain">
            <div className="right-content-div">
              <div className="d-flex justify-content-center">
                <span className="logIn">Forgot Password</span>
              </div>

              <div className="mt-4">
                {error ? (
                  <Infomation
                    text={
                      <ul>
                        <li>Password must have at least 12 characters</li>
                        <li>
                          A mixture of both uppercase and lowercase letters
                        </li>
                        <li>
                          Inclusion of at least one special character, e.g., ! @
                          # ?{" "}
                        </li>
                      </ul>
                    }
                  />
                ) : (
                  ""
                )}
              </div>
              <div className="form-password mt-4">
                <Label className="HelveticaMedium">New Password</Label>
                <input
                  className="form-control"
                  placeholder="Enter New Password"
                  type={eye ? "password" : "text"}
                  required
                  onChange={handleChangePass}
                  id="resetPassword"
                />
                {eye ? (
                  <i
                    className="pi pi-eye-slash password-eye pointer"
                    style={{ color: "#94989E" }}
                    onClick={() => setEye(!eye)}
                  ></i>
                ) : (
                  <i
                    className="pi pi-eye password-eye pointer"
                    style={{ color: "#94989E" }}
                    onClick={() => setEye(!eye)}
                  ></i>
                )}
              </div>
              <div className="form-password mt-4">
                <Label className="HelveticaMedium">Confirm New Password</Label>
                <input
                  className="form-control"
                  placeholder="Confirm New Password"
                  type={confirmEye ? "password" : "text"}
                  required
                  onChange={handleconfirmPass}
                  id="resetConfirmPassword"
                />
                {confirmEye ? (
                  <i
                    className="pi pi-eye-slash password-eye pointer"
                    style={{ color: "#94989E" }}
                    onClick={() => setConfirmEye(!confirmEye)}
                  ></i>
                ) : (
                  <i
                    className="pi pi-eye password-eye pointer"
                    style={{ color: "#94989E" }}
                    onClick={() => setConfirmEye(!confirmEye)}
                  ></i>
                )}
              </div>
              {infoError ? (
                <Infomation
                  text="Passwords are not same"
                  type="warning"
                ></Infomation>
              ) : (
                ""
              )}
              <div className="mt-4">
                <button
                  className=" btn btn-primary w-100"
                  type="submit"
                  id="resetSubmit"
                >
                  Continue
                </button>
              </div>
              <div className="mt-4 d-flex justify-content-center">
                <Link to="/bioAuthentication" className="textDecoration">
                  <span className="backTologin">Cancel</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </form>
      <Loader open={loading} />
    </>
  );
}
